import { useTranslation } from '../../../i18n/i18n';
import HostedDesktopLayout from '../../../layouts/DesktopLayout';
import HostedActionRow from '../../../components/hosted/ActionRow';
import HostedFaqModal from '../../../components/hosted/FaqModal';
import { useFaqModal } from '../../../hooks/useFaqModal';
import HostedNeedHelpSection from '../../../components/hosted/NeedHelpSection';
import HostedAppPickerScreen from '../shared/AppPickerScreen';
import { type AppPickerPageProps } from '../../types';

export default function HostedDesktopAppPickerPage({
  tokens,
  handlerApps,
  recommendedHandlerAppUuids,
  onSelect,
  onCancel,
}: AppPickerPageProps) {
  const { t } = useTranslation();
  const faq = useFaqModal();

  return (
    <HostedDesktopLayout>
      <div className="flex flex-1 items-center justify-center w-full">
        <div className="flex flex-col items-center gap-6 text-center max-w-lg w-full">
          <div>
            <h2
              data-testid="app-picker-title"
              className="text-xl font-semibold text-foreground text-center"
            >
              {t('appPicker.title')}
            </h2>
            <p className="mt-2 text-sm text-muted-foreground text-center">
              {t('appPicker.subtitle')}
            </p>
          </div>

          <HostedAppPickerScreen
            className="max-h-[calc(50vh+5rem)]"
            tokens={tokens}
            handlerApps={handlerApps}
            recommendedHandlerAppUuids={recommendedHandlerAppUuids}
            onSelect={onSelect}
          />

          <HostedActionRow
            className="my-6 w-full max-w-lg"
            secondary={{ label: t('agentStart.cancel'), onClick: onCancel }}
          />

          <HostedNeedHelpSection
            topics={['whatAreWallets', 'whyNotSupported']}
            onSelectTopic={faq.open}
          />
          <HostedFaqModal {...faq.modal} />
        </div>
      </div>
    </HostedDesktopLayout>
  );
}
